module.exports = __webpack_public_path__ + "static/media/icon-sort.4ba9f527.svg";